
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mlbattprot-eu-project",
      function () {
        return require("private-next-pages/mlbattprot-eu-project/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mlbattprot-eu-project"])
      });
    }
  